import type { SVGProps } from 'react';
const SvgViewCarousel = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#view_carousel_svg__a)">
      <path
        fill="currentColor"
        d="M7 19h10V4H7v15Zm-5-2h4V6H2v11ZM18 6v11h4V6h-4Z"
      />
    </g>
    <defs>
      <clipPath id="view_carousel_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgViewCarousel;
